import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {
  transform(value: number, total: number = 1, fractionDigits: number = 0): string {
    const percentage = (value / total) * 100;
    return percentage.toFixed(fractionDigits);
  }
}
